export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Binnacle.vue?vue&type=template&id=049affab&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Binnacle.vue?vue&type=template&id=049affab&scoped=true
// module id = 1896
// module chunks = 31